// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"20a2270f","952":"d60a6134","977":"509cffd7"}[chunkId] + ".chunk.js";
};